import { render, staticRenderFns } from "./DashboardViewEditingSave.vue?vue&type=template&id=20cf7d44"
import script from "./DashboardViewEditingSave.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports